import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerFatturazioneGeneratePackagePRModalComponent } from './worker-fatturazione-generate-package-pr-modal';

export const WorkerFatturazioneGeneratePackagePRModalModule: string = ng
    .module('worker-fatturazione-generate-package-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerFatturazioneGeneratePackagePRModalComponent', WorkerFatturazioneGeneratePackagePRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/worker-fatturazione-generate-package-pr-modal/worker-fatturazione-generate-package-pr-modal.module.ts